import { Products } from "../MainTab/ProductWindow/Products";
let selectedProduct = "";
let previousSelectedProduct = "";
export function getSelectedProductName() {
  return selectedProduct;
}

export function getSelectedProductInformation() {
  if (selectedProduct === "") {
    return null;
  }

  return Products.Products[selectedProduct];
}

export function getProductInformation(product: string) {
  return Products.Products[product];
}

export function getPreviousSelectedProductName() {
  return previousSelectedProduct;
}

export function setSelectedProduct(product: string) {
  previousSelectedProduct = selectedProduct;
  selectedProduct = product;
}

export function getGeneralInformation() {
  return Products.General;
}

export function getAllProducts(): { [key: string]: IProduct } {
  return Products.Products;
}

export interface IProducts{
  General: IProductsGeneral;
  Products: { [key: string]: IProduct };
}

export interface IProductsGeneral {
  workshopPdf: {
    english: string;
    german: string;
  };
  trustCenter: string;
}

export interface IProductCategoryLinks{
    getStarted?: boolean;
    knowledgeBase?: string;
    legacyDocumentation?: string;
    documentation?: string;
    roadmap?: string;
    ideas?: string;
    updates?: string;
    showVideoTrainings?: boolean;
    showWorkshop?: boolean;
    apiDocs?: string;
    showTrustCenter?: boolean;
}

export interface IProduct {
  information: {
    title: string;
    icon: string;
    logo?: string;
  };
  categoryLinks: IProductCategoryLinks
  categoryLinksUser: IProductCategoryLinks
  getStarted: {
    header: {
      titleId: string;
      altTitle: string;
      descriptionId: string;
      altDescription: string;
      primaryButtonTextId: string;
      primaryButtonText: string;
      secondaryButtonTextId?: string;
      secondaryButtonText?: string;
      image: string;
      logoText?:string;
      german: {
        videoLink?: string;
        primaryButtonLink: string;
        secondaryButtonLink?: string;
      };
      english: {
        videoLink?: string;
        primaryButtonLink: string;
        secondaryButtonLink?: string;
      };
    };
    specifications: Array<{
      icon: string;
      title: string;
      text: string;
      altTitle: string;
      altText: string;
    }>;
    sections: Array<{
      navTitle?: string;
      title: string;
      text: string;
      img: string;
      checkmarks?: string[];
      id: string;
    }>;
    cardData?: Array<{
      title: string;
      description: string;
      image: string;
      link: string;
    }>;
  };
}
